export default function Disclaimer() {
  return (
    <div data-testid="disclaimer-footer" className="mt-16 border-t border-white/5 py-6 px-4 text-center text-xs text-white/40">
      <p className="max-w-2xl mx-auto">
        Bu uygulama <strong className="text-white/60">yalnızca eğlence amaçlıdır</strong>. Verilen yorumlar tıbbi, hukuki veya finansal tavsiye değildir.
        18 yaş altı kullanıcılar için uygun değildir.
      </p>
      <p className="mt-2">© {new Date().getFullYear()} FalZilla · <a href="/kvkk" className="hover:text-[#D4AF37]">KVKK</a> · <a href="/kullanim" className="hover:text-[#D4AF37]">Kullanım Şartları</a></p>
    </div>
  );
}
